import React from 'react'
const moment=require('moment-jalaali');

const MoveCard = ({data}) => {
  return (
    
    <div className='movingCard'>
      <h4>مقادیر آخرین پکت</h4>
      <div style={{display:'flex',flexDirection:'column',justifyContent:'center',color:'rgb(3, 119, 61)'}}>
        <span className='spanDetails'> <span>🕗 logTime</span> <span>{data?.logTime?moment(data?.logTime).format('jYYYY-jMM-jDD HH:mm:ss'):0}</span></span>
        <span className='spanDetails'> <span>🟠 packetCounter </span><span>{data?.packetCounter?data?.packetCounter:0}</span></span>
        <span className='spanDetails'> <span>⚫ batteryLevel </span><span>{data?.batteryLevel?data?.batteryLevel:0}</span></span>
        <span className='spanDetails'><span>🔴 temperature  </span><span>{data?.temperature?data?.temperature:0}</span></span>
        <span className='spanDetails'> <span>🔵 humidity </span><span>{data?.humidity?data?.humidity:0}</span></span>
        <span className='spanDetails'> <span>🟢 chewing </span><span>{data?.chewing?data?.chewing:0}</span></span>
        <span className='spanDetails'> <span>🟡 standing </span><span>{data?.standing?data?.standing:0}</span></span>
        <span className='spanDetails'> <span>💤 sleeping </span><span>{data?.sleeping?data?.sleeping:0}</span></span>
        <span className='spanDetails'> <span>⭕ rumination </span><span>{data?.rumination?data?.rumination:0}</span></span>
        <span className='spanDetails'> <span>🌐 walking </span><span>{data?.walking?data?.walking:0}</span></span>
        <span className='spanDetails'> <span>🔘 activity </span><span>{data?.activity?data?.activity:0}</span></span>
        <span className='spanDetails'> <span>⚪ unrest </span><span>{data?.unrest?data?.unrest:0}  </span></span>




      </div>
    </div>
  
  )
}

export default MoveCard
